// Helper function to format error messages from API responses
export const formatError = (error) => {
  const errorMessage = error?.response?.data?.error;
  
  if (!errorMessage) {
    return 'An unexpected error occurred';
  }
  
  // If it's already a string, return it
  if (typeof errorMessage === 'string') {
    return errorMessage;
  }
  
  // If it's an array, format it
  if (Array.isArray(errorMessage)) {
    return errorMessage.map(err => {
      if (typeof err === 'string') return err;
      if (typeof err === 'object' && err.msg) return err.msg;
      return JSON.stringify(err);
    }).join(', ');
  }
  
  // If it's an object, try to extract message or stringify
  if (typeof errorMessage === 'object') {
    if (errorMessage.msg) return errorMessage.msg;
    if (errorMessage.message) return errorMessage.message;
    return JSON.stringify(errorMessage);
  }
  
  // Fallback
  return String(errorMessage);
};

